import { render, staticRenderFns } from "./ImportEverything.vue?vue&type=template&id=35fcf1f4&scoped=true"
import script from "./ImportEverything.vue?vue&type=script&lang=js"
export * from "./ImportEverything.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35fcf1f4",
  null
  
)

export default component.exports